import { CommonModule, isPlatformBrowser } from '@angular/common';
import { APP_INITIALIZER, ApplicationRef, createComponent, EnvironmentInjector, isDevMode, NgModule, PLATFORM_ID } from '@angular/core';
import { SawdustDevToolsComponent } from './sawdust-devtools.component';

const initDevTools = (appRef: ApplicationRef, environmentInjector: EnvironmentInjector, platformId: object) => () => {
  // Only initialize in development mode
  if (!isDevMode()) {
    return;
  }

  const isBrowser = isPlatformBrowser(platformId);

  // Create the DevTools component
  if (isBrowser) {
    const hostElement = document.createElement('div');
    document.body.appendChild(hostElement);

    const componentRef = createComponent(SawdustDevToolsComponent, {
      environmentInjector,
      hostElement
    });

    // Manually trigger change detection
    componentRef.changeDetectorRef.detectChanges();

    // Attach to the application
    appRef.attachView(componentRef.hostView);
  }
};

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initDevTools,
      deps: [ApplicationRef, EnvironmentInjector, PLATFORM_ID],
      multi: true
    }
  ]
})
export class SawdustDevToolsModule {}
